import { AppBar, Box, Button, Container, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { cloneDeep, isEqual } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { reloadFacilities, updateFacility } from '../../../actions/facilities/facilities.actions'
import AddonCategories from '../../../components/Cards/Facility/AddonCategories'
import PermitedMealAdjustments from '../../../components/Cards/Facility/PermittedMealAdjustments'
import TimeBlocks from '../../../components/Cards/Facility/TimeBlocks'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'

const useStyles = makeStyles((theme) => ({
	root: {
		// flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	container: {
		padding: 24,
		marginBottom: '20px'
	},
	// appBar: {
	// 	top: 'auto',
	// 	bottom: 0,
	// 	paddingRight: '0px !important'
	// },
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important',
		zIndex: 1300
	}
}))

const ActivitySetup = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	const history = useHistory()

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	const loading = useSelector((state) => state.specific.facilities.loading)

	const [current, setCurrent] = useState(null)
	const [isSaveShown, setIsSaveShown] = useState(false)

	useEffect(() => {
		dispatch(reloadFacilities())
	}, [])

	useEffect(() => {
		if (params.facilityId && selectedFacility) {
			setCurrent(cloneDeep(selectedFacility))
			// dispatch(getApartmentList(selectedFacility.market_id))
		}
	}, [params.facilityId, selectedFacility])

	useEffect(() => {
		if (current && selectedFacility) {
			let facilityEqual = !isEqual(current, selectedFacility)

			setIsSaveShown(facilityEqual)
		}
	}, [current, selectedFacility])

	const saveSelectedFacility = () => {
		const fieldsToCompare = ['time_blocks', 'permitted_meal_adjustments', 'addons_categories']

		const updates = {}
		fieldsToCompare.forEach((field) => {
			if (!isEqual(current[field], selectedFacility[field])) {
				updates[field] = current[field]
			}
		})

		if (Object.keys(updates).length > 0) {
			dispatch(updateFacility(selectedFacility._id, updates))
		}
	}

	const clearChanges = () => {
		setCurrent(cloneDeep(selectedFacility))
	}

	return (
		<Box>
			{current ? (
				<Box className={classes.container}>
					<Box>
						<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
							Activity Setup
						</Typography>
						<TimeBlocks selectedFacility={current} setCurrent={setCurrent} />
						<PermitedMealAdjustments selectedFacility={current} setCurrent={setCurrent} />
						<AddonCategories selectedFacility={current} setCurrent={setCurrent} />
					</Box>
					{isSaveShown ? (
						<AppBar position="fixed" color="primary" className={classes.appBar}>
							<Toolbar>
								<Container maxWidth="md">
									<Button
										variant="contained"
										color="secondary"
										disabled={loading}
										style={{ marginRight: '8px' }}
										onClick={() => saveSelectedFacility()}>
										Save Changes
									</Button>
									<Button variant="outlined" color="secondary" onClick={clearChanges}>
										Cancel
									</Button>
								</Container>
							</Toolbar>
						</AppBar>
					) : null}
				</Box>
			) : null}
			{loading ? <LoadingOverlay /> : null}
		</Box>
	)
}

export default ActivitySetup
